const toDate = value => {
  if (value instanceof Date) {
    return value;
  }
  return new Date(value);
};

const toComparable = (isPinned, time) => (isPinned ? 10000000000000 : 0) + time;

export default function sortPosts(posts = []) {
  return posts.sort((postA, postB) => {
    const postAValue = toComparable(postA.isPinned, toDate(postA.lastActivityDate).getTime());
    const postBValue = toComparable(postB.isPinned, toDate(postB.lastActivityDate).getTime());
    return postBValue - postAValue;
  });
}



// WEBPACK FOOTER //
// ./app/services/sort-posts.js